module.exports = __webpack_public_path__ + "img/symbol_arrow2blue.8136f64c.png";